<template>

  <v-btn
    elevation   = "0"
    x-small
    color       = "primary"
    @click      = "$emit('remove')"
  >
    {{ label }}

    <v-icon
      right
      dark
    >
      mdi-close
    </v-icon>

  </v-btn>

</template>

<script>

export default {

  // #region Properties

  props: {
    label: String
  }

  // #endregion Properties

}

</script>